import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ContactForm",
    component: () =>
        __SERVER__ ? require("./dynamic-contact-form-view") : import("./dynamic-contact-form-view")
});

export default definition;
